import formYoutubeInteractableContent from './formYoutubeInteractableContent';

export default {
  title: 'Youtube Interactable Form',
  attributeName: 'youtubeInteractableForm',
  getURL: 'mainHubs/mainHubId/youtube/interactables',
  createURL: 'mainHubs/mainHubId/youtube/interactables',
  updateURL: 'mainHubs/mainHubId/youtube/interactables',
  sessionParams: ['configId'],
  autoUpdate: false,
  removeURL: '',
  idAttribute: 'id',
  idUpdate:true,
  noArea:true,
  goBack:true,
  formConfig: [formYoutubeInteractableContent],
};